// extracted by mini-css-extract-plugin
export default {"container":"style_container__6UF9d","content":"style_content__7ydTb","title":"style_title__MwB5C","title_header":"style_title_header__HYu6D","title_inner":"style_title_inner__8livg"};